export const WebcamWidths = {
  WEBCAM_MOBILE: 960,
  WEBCAM_DESKTOP: 1280
};

export const VIDEO_INPUT = 'videoinput';
export const FRONT_CAMERA = 'front';

export const BLUR_THRESHOLD = 400;
// const MOBILE_BLUR_THRESHOLD = 250;
